RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PdfPanel = App.views.Panel.mixin({
        template: '#dashboardPDFWidgetTemplate',
        className: function () {
            const me = this;
            return ['pdf-panel', me.dashboardModel.getSize()].join(' ');
        },

        serializeData: function () {
            const me = this;

            return {
                allowPageBreaks: _.result(me.dashboardModel, 'allowPageBreaks'),
                title: me.dashboardModel.getTitle(),
                subtitle: me.dashboardModel.getSubtitle()
            };
        },

        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        },

        onRender: function () {
            const me = this;

            me.showContent();
        }
    });

    views.NoHeadingPdfPanel = views.PdfPanel.extend({
        template: '#dashboardPDFWidgetNoHeadingTemplate',
        serializeData: function () {
            const me = this;

            return {
                allowPageBreaks: _.result(me.dashboardModel, 'allowPageBreaks')
            };
        }
    });
});
